function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Spinner from "../spinner";
import PropTypes from 'prop-types';

class UploadFile extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", e => {
      if (e.target.files.length < 1) return null;
      const file = e.target.files[0];

      if (this.props.preUpload) {
        this.props.preUpload().then(res => {
          if (!(res && res.includes('undefined'))) {
            this.props.uploadStore.upload({
              file,
              url: res ? res : this.props.url,
              onOk: res => {
                this.props.growlStore.showSuccess('You have successfully uploaded an attachment.');
                return this.props.onOk(res);
              },
              onError: this.props.onError
            });
          }
        }).catch(error => {
          throw new Error(error.message);
        });
        return;
      }

      this.props.uploadStore.upload({
        file: e.target.files[0],
        url: this.props.url,
        onOk: res => {
          this.props.growlStore.showSuccess('You have successfully uploaded an attachment.');
          return this.props.onOk(res);
        },
        onError: this.props.onError
      });
    });
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "upload-wrapper"
    }, /*#__PURE__*/React.createElement("input", {
      className: "display-none",
      ref: "attachment",
      type: "file",
      onChange: this.onChange
    }), /*#__PURE__*/React.createElement("button", {
      type: "button" // @ts-ignore
      ,
      onClick: () => this.refs.attachment.click(),
      className: "button button-medium button--secondary"
    }, this.props.label || 'Upload'), this.props.uploadStore.loading ? /*#__PURE__*/React.createElement(Spinner, {
      inline: true
    }) : null);
  }

}

UploadFile.propTypes = {
  onOk: PropTypes.func,
  onError: PropTypes.func,
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  uploadStore: PropTypes.object,
  growlStore: PropTypes.object
};
export default inject('uploadStore', 'growlStore', 'expertStore')(observer(UploadFile));